const german = {
    GENERAL: {
        LUF: "Lookup files herunterladen",
        CREATED: "Erstellt",
        COMPANY_ADMIN: "Firmenadmin",
        SHOW_TERMS: "AGB anzeigen",
        EXPEDIENTS_AGENCIES: "Expedient_innen nach Agenturen",
        EXPEDIENTS: "Expedient_innen",
        AGENCIES: "Agenturen",
        COMPANIES: "Firmen",
        DATASETS: "Datensätze",
        TRAVELERS: "Reisende",
        COMPANY: "Firma",
        UPDATE_DATA: "Daten aktualisieren",
        PER_PERSON_ABBREVATION: "p. P.",
        NEW: "neu",
        OLD: "alt",
        CALCULATION: "Berechnung",
        ADD_TO: "Hinzufügen zu",
        TYPE: "Typ",
        AND: "und",
        OR: "oder",
        FUEL_CONSUMPTION: "Treibstoffverbrauch",
        GUEST: "Gast",
        GUESTS: "Gäste",
        ERROR: "Fehler",
        LITER: "Liter",
        KW_H: "kWh",
        DISTANCE: "Distanz",
        NO_AGENCY: "Keine Agentur",
        NONE: 'Keine',
        CHECKOUT: "Checkout",
        ASTERIKS: "*",
        STAR: 'Stern',
        STARS: 'Sterne',
        CALENDAR: 'Kalendar',
        CUSTOMER: 'Kund_in',
        NO_CUSTOMER: "Keine Kund_in",
        CREATE: 'Erstellen',
        POWERED_BY: "Unterstützt von",
        DESCRIPTION: "Beschreibung",
        START_DATE: "Startdatum",
        ADD_TITLE: "Titel hinzufügen",
        ADD_DESCRIPTION: "Beschreibung hinzufügen",
        END_DATE: "Enddatum",
        TRAVEL_COMPONENT_NAME: "Reisebaustein-Name",
        JOURNEY_NAME: "Name der Reise",
        CONTACT_PERSON: "Kontaktperson",
        CUSTOMER_FIRST_NAME: "Kunde_in Vorname",
        CUSTOMER_LAST_NAME: "Kunde_in Nachname",
        CUSTOMER_EMAIL: "Kunde_in E-Mail",
        CUSTOMER_PHONE: "Kunde_in Telefonnummer",
        CUSTOMER_STREET: "Kunde_in Straße",
        CUSTOMER_CITY: "Kunde_in Stadt",
        CUSTOMER_HOUSE_NUMBER: "Kunde_in Hausnummer",
        CUSTOMER_ZIP_CODE: "Kunde_in Postleitzahl",
        TOTAL_EMISSIONS: "Summe Emissionen",
        BACK: "Zurück",
        YES: "Ja",
        UPDATE_TRAVEL_COMPONENT: "Update Travel Components",
        NO: "Nein",
        ADMIN: "Admin",
        EMAIL: "E-Mail",
        PHONE: 'Telefonnummer',
        DAY: "Tag",
        DAYS: "Tage",
        ABORT: "Abbrechen",
        SAVE: "Speichern",
        LOAD: "Laden",
        TRANSPORT: "Leistungen",
        ACCOMMODATION: "Unterkunft",
        UNDERTAKING: "Aktivität",
        ADD: "Hinzufügen",
        PROCEED: "Weiter",
        TOTAL: "Gesamt",
        JOURNEY: "Reise",
        PERSON: "Person",
        PERSONS: "Personen",
        DURATION: 'Dauer',
        FROM: "von",
        LAST_EDITED: "zuletzt bearbeitet",
        EDITED: "Bearbeitet",
        DELETE: "Löschen",
        SEARCH: "Suche",
        SHARE: "Teilen",
        NAME: "Name",
        DATE_OF_ACTIVITY: "Datum",
        TRANSFERS: "Umstiege",
        EMISSIONS: "Emissionen",
        SPINNER: "Spinner, welcher solange angezeigt wird, bis Dateien geladen sind.",
        COPIED: "Kopiert",
        PASSENGER: 'Person',
        PASSENGERS: 'Personen',
        OPTION_OPTIONAL: 'Optional',
        FOR: "für",
        CALCULATE: "Berechnen",
        CALCULATE_AGAIN: "Erneut berechnen",
        UNDO: "Rückgängig machen",
        DATE: "Datum",
        FAILED: "Fehlgeschlagen",
        TOTAL_CO2: "Gesamt CO₂",
        RESET: "Zurücksetzen",
        SELECT_ALL: "Alles auswählen",
        UNSELECT_ALL: "Auswahl aufheben",
        OK: "OK",
        EMISSIONS_CALCULATED: "Emissionen erfolgreich berechnet!",
        HOTEL_EMISSIONS_CALCULATED_WITH_SCOPE: "Emissionen wurden erfolgreich auf der Ebene von {{scope}} berechnet!",
        GROUP_TRAVEL_COMPONENTS: "Reisebausteine gruppieren",
        UNGROUP_TRAVEL_COMPONENTS: "Reisebausteine ungruppieren",
        TRAVELERS_COUNT: "Anzahl Reisende",
        EMISSIONS_PER_PERSON: "Emissionen pro Person",
        PER_PERSON: "pro Person",
        INVITE: "Einladen",
        TRAVEL_COMPONENTS: "Reisebausteine",
        TRAVEL_COMPONENTS_DATIV: "Reisebausteinen",
        CO2_E_EXPLANATION: 'Alle Emissionen sind in "kg CO₂-Äquivalent" (kg CO₂e) angegeben; dies entspricht der Menge CO₂, die denselben klimaerwärmenden Effekt hat wie die Summe aller produzierten Emissionen, einschließlich anderer Treibhausgase (z.B. Methan) und Effekte (Kondensstreifen, Ozonbildung).',
        AGENCY: "Agentur",
        AGENCY_NAME: "Agenturname",
        USER: "Benutzer_in",
        USER_NAME: "Benutzer_innenname",
        COMPANY_NAME: "Firmenname",
        FIRST_CONTACT_PERSON_FIRST_NAME: "1. Ansprechpartner_in Vorname",
        FIRST_CONTACT_PERSON_LAST_NAME: "1. Ansprechpartner_in Nachname",
        SECOND_CONTACT_PERSON_FIRST_NAME: "2. Ansprechpartner_in Vorname",
        SECOND_CONTACT_PERSON_LAST_NAME: "2. Ansprechpartner_in Nachname",
        FIRST_CONTACT_PERSON: "1. Ansprechpartner_in",
        SECOND_CONTACT_PERSON: "2. Ansprechpartner_in",
        STREET: "Straße",
        FIRST_NAME: "Vorname",
        LAST_NAME: "Nachname",
        HOUSE_NUMBER: "Hausnummer",
        ADDITIONAL_ADDRESS_INFORMATION: "Zusätzliche Informationen",
        ZIP_CODE: "Postleitzahl",
        CITY: "Ort",
        TELEPHONE_NUMBER_WITH_AREA_CODE_LABEL: "Telefonnummer mit Vorwahl",
        COUNTRY_LABEL: "Land",
        COUNTRY_CODE_LABEL: "Ländervorwahl",
        HELP: "Hilfe",
        TERMS: "AGB",
        AIRPORT: 'Flughafen',
        HOTEL: 'Hotel',
        FLIGHT: "Flug",
        EINEN: 'einen',
        EIN: 'ein',
        EINE: 'eine',
        AIRLINE: "Airline",
        COUNTRY: 'Land',
        COMPANY_EMAIL: 'Firmen E-Mail',
        AGENCY_EMAIL: 'Agentur E-Mail',
        EMAIL_CONTACT_PERSON: '{{contactPerson}} E-Mail',
        SKIP: "Überspringen",
        LOADING: "Laden...",
        CO2KGE: "CO₂KgE",
        EDIT: 'Bearbeiten',
        WEITEREN: 'weiteren',
        WEITERES: 'weiteres',
        USE_FIXED_DATES: "Feste Daten verwenden",
        ATTACH: "anhängen",
        REPLACE: "ersetzen",
        CREATE_JOURNEY: "Reise erstellen",
        ADDRESS: "Addresse",
        START: "Start",
        DESTINATION: "Ziel",
        STOPOVER: "Zwischenstop",
        STOPOVERS: "Zwischenstops",
    },
    ARIA: {
        SORT: "Sort",
        CLOSE_OVERLAY: "Close overlay",
        CALENDAR: "Kalendar",
        KLIMALINK_LOGO: "Das Logo des KlimaLink Vereins",
    },
    HINTS: {
        COMMON: {
            ROUNDED_VALUES: "Werte pro Gruppe sind gerundet und können leicht abweichen",
        },
        EMISSION_CALCULATION: {
            COMMON: {
                TEXT: "Emissionen wurden auf TIER {{tier}} berechnet.",
                DIFFERENT_CALCULATED_CO_KG_E: "Die neuberechneten Emission unterscheiden sich von den zum Zeitpunkt des abspeichern berechneten Emissionen (neu: {{currentEmissionsCo2KgE}}, alt: {{previousEmissionsCo2KgE}})",
            },
            HOTEL: {
                TEXT: "Die Emissionen wurden auf {{tier}} berechnet.",
                PROPERTY: "Hotelebene",
                CITY: "Stadtebene",
                REGION: "Regionsebene",
                COUNTRY: "Landesebene"
            },
            FLIGHT: {
                BETTER_CALCULATION_POSSIBILITY_SPECIFIC: "Die Emissionen von diesem Flugabschnitte können Sie genauer berechnen, indem Sie weitere Informationen wie Airline, Flugzeugtyp oder Serviceklasse hinzufügen.",
                BETTER_CALCULATION_POSSIBILITY_GENERAL: "Die Emissionen von mindestens einem der Flugabschnitte können Sie genauer berechnen, indem Sie weitere Informationen wie Airline, Flugzeugtyp oder Serviceklasse hinzufügen.",
                PRECISE_CALCULATED: "Die Emissionen wurden mit Airline und/oder Flugzeugtyp und/oder Serviceklasse berechnet. Dies führt zur genaueren Emissionsberechnung.",
                DIFFERENT_CALCULATED_CO_KG_E_SINGULAR: "Die neuberechneten Emission für den Flugabschnitt {{leg}} unterscheiden sich von den zum Zeitpunkt des abspeichern berechneten Emissionen (neu: {{currentEmissionsCo2KgE}}, alt: {{previousEmissionsCo2KgE}})",
                DIFFERENT_CALCULATED_CO_KG_E_PLURAL: "Für folgende Flugabschnitte unterscheiden sich die neuberechneten Emissionen von den zum Zeitpunkt des abspeichern berechneten Emissionen: {{legsWithValues}}",
            },
            CAR_BUS: {
                DEFAULT_DISTANCE_VALUE_USED: "Eine standardisierte Distanz wurde verwendet.",
                DERIVED_FUEL_CONSUMPTION_USED: "Der Treibstoffverbrauch {{derivedFuelConsumption}} abgeleitet",
                FUEL_CONSUMPTION: "Der angebenene Treibstoffverbrauch wurde zur Emissionsberechnung verwendet.",
                CAR_CATEGORY_DAYS_OF_USE_USED: "Zur Emissionsberechnung wurde die Fahrzeugkategorie {{carCategory}} und Dauer von {{days}} verwendet.",
                DISTANCE_USED: "Zur Emissionsberechnung wurde die angegebene Distanz verwendet und der angegebene Treibstoffverbrauch {{derivedFuelConsumption}} abgeleitet.",
                DAYS_OF_USE: "Über die Anzahl der gefahrenen Tage wird die zurückgelegten Distanz pro Tag geschätzt. Der Treibstoffverbrauch ergibt sich aus einem standard Wert für den angebenen Fahrzeugtyps.",
                FROM_CAR_TYPE: "von Auto-Typ",
                FROM_BUS_TYPE: "von Bus-Typ",
                FROM_ACRISS_CODE: "von Acriss-Code",
                FLAT_RATE_DISTANCE: "Eine pauschale Distanz wurde festgelegt.",
                BETTER_CALCULATION_POSSIBILITIES: "Sie können die Emissionen genauer berechnen, indem Sie weitere Informationen wie {{values}} hinzufügen.",
            },
        },
        BUNDLE: {
            SAVED_DATA: "Dies sind gespeicherte Daten.",
            HOTEL_NEW_NAME: "Das Hotel {{originalHotelName}} heißt jetzt {{newHotelName}}.",
            HOTEL_DISCONTINUED: "Das Hotel {{originalHotelName}} existiert nicht mehr.",
            HOTEL_CLASS_CHANGED: "Die vorherigen Sterne waren {{originalHotelClass}} und sind jetzt {{newHotelClass}}.",
            CALCULATED_WITH_NEW_DATA: "Diese Emissionen wurden mit den neuen Daten berechnet.",
            FLIGHT_NUMBER_AND_DATE_STRIPPED_OF_LEG: "Die Verbindung {{flightNumber}}, {{flightDate}} ({{leg}}) existiert nicht mehr. Deswegen wurden Flugnummer - und Datum, Airline und Flugzeugtyp entfernt. Die Emissionsberechnung für diese Abschnitte wurde ohne Flugzeugtyp und Airline durchgeführt. Dies führt zu ungenaueren Emissionsberechnungen.",
            FLIGHT_NUMBER_AND_DATE_STRIPPED_OF_LEGS: "Die Verbindungen {{legs}} existieren nicht mehr. Deswegen wurden Flugnummer - und Datum, Airline und Flugzeugtyp entfernt. Die Emissionsberechnung für diese Abschnitte wurde ohne Flugzeugtyp und Airline durchgeführt. Dies führt zu ungenaueren Emissionsberechnungen.",
            NEW_AIRPORT_UPON_LOADING: "Der ursprüngliche Flughafen ({{originalAirportName}}) hat denselben IATA-Code ({{iata}}), aber jetzt einen anderen Namen ({{newAirportName}}). Die Emissionen wurden basierend auf dem neuen Flughafen und dessen neuem Standort berechnet. Bitte überprüfen Sie den Flughafen und bearbeiten Sie bei Bedarf den Flughafen, um die Emissionen erneut zu berechnen.",
            NEW_AIRPORT_UPON_LOADING_SAME_COUNTRIES: "Hinweis: Der ursprüngliche Flughafen befindet sich in {{originalAirportCountry}}, der neue Flughafen befindet sich in {{newAirportCountry}}. Da sie sich im selben Land befinden, kann davon ausgegangen werden, dass sich der Standort des Flughafens nicht geändert hat und die berechneten Emissionen dieselben sind wie die ursprünglichen.",
            NEW_AIRPORT_UPON_LOADING_DIFFERENT_COUNTRIES: "Hinweis: Der ursprüngliche Flughafen befindet sich in {{originalAirportCountry}}, der neue Flughafen befindet sich in {{newAirportCountry}}. Da sie sich in verschiedenen Ländern befinden, kann davon ausgegangen werden, dass sich der Standort des Flughafens geändert hat und die berechneten Emissionen im Vergleich zu den ursprünglichen abweichen.",
            NEW_AIRPORTS_UPON_LOADING: "Die ursprünglichen Flughäfen ({{originalAirportNames}}) haben dieselben IATA-Codes ({{iatas}}), aber jetzt andere Namen ({{newAirportNames}}). Die Emissionen wurden basierend auf den neuen Flughäfen und deren neuen Standorten berechnet. Bitte überprüfen Sie die Flughäfen und bearbeiten Sie bei Bedarf die Flughäfen, um die Emissionen erneut zu berechnen.",
            NEW_AIRPORTS_UPON_LOADING_SAME_COUNTRIES: "Hinweis: Alle ursprünglichen Flughäfen befinden sich weiterhin in denselben Ländern (ursprüngliche Länder: {{originalAirportCountries}}, neue Länder: {{newAirportCountries}}). Da sie sich in denselben Ländern befinden, kann davon ausgegangen werden, dass sich die Standorte der Flughäfen nicht geändert haben und die berechneten Emissionen dieselben sind wie die ursprünglichen.",
            NEW_AIRPORTS_UPON_LOADING_DIFFERENT_COUNTRIES: "Hinweis: Mindestens einer der Flughäfen befindet sich jetzt in einem anderen Land (ursprüngliche Länder: {{originalAirportCountries}}, neue Länder: {{newAirportCountries}}). Da sich mindestens einer der Flughäfen in verschiedenen Ländern befindet, kann davon ausgegangen werden, dass sich der Standort dieses/dieser Flughafens/Flughäfen geändert hat und die berechneten Emissionen im Vergleich zu den ursprünglichen abweichen.",
        },
        JOURNEY: {
            DROPPABLE_DISABLED_MOVING_GROUP: "Gruppe von {{activity}} kann nicht hierhin bewegt werden, da ihre Dauer die Reisedauer über- oder unterschreiten würde.",
            DROPPABLE_DISABLED_HOTEL_JOURNEY_LAST_DAY: "Hotel kann nicht hierhin bewegt werden, da Hotelaufenthalte über Nacht sind. Verlängern Sie die Reise um einen Tag.",
            ARROW_DOWN_HOTEL_ACTIVITY_DISABLED: "Hotel kann nicht einen Tag nach unten bewegt werden, da Hotelaufenthalte über Nacht sind. Verlängern Sie die Reise um einen Tag.",
            ARROW_DOWN_HOTEL_DAY_DISABLED: 'Tag kann nicht nach unten bewegt werden, da sich mindestens ein Hotel im Tag befindet. Hotelaufenthalte sind über Nacht. Bitte verlängen Sie die Reise um einen Tag.',
            ARROW_DISABLED_CAR_BUS_WITH_ROUTE_AT_DAY: 'Tag kann nicht bewegt werden, da da sich mindestens ein Auto mit einer Route an dem Tag befindet. Reisebausteine vom Typ Auto/Bus, welche eine Route haben, müssen immer in der Gruppe bewegt werden.',
            ADD_HOTEL_ACTIVITY_LAST_JOURNEY_DAY: 'Eine Unterkunft kann nicht am letzten Tag der Reise hinzugefügt werden, da Unterkünfte immer über Nacht sind.',
            HOTEL_DATES_REMOVED: "Ihre Reise hat keine exaktes Datum, Ihr ursprünglicher Hotelaufenthalt hat jedoch ein genaues Datum. Das Datum des Hotelaufenthalts wurden durch die Anzahl der Nächte ersetzt.",
            FLIGHT_CO2_KG_E_DEPENDS_ON_DATE: "Die Emissionen dieses Reisebausteines sind abhängig vom Datum. Wenn Sie den Reisebaustein auf ein anderes Datum bewegen, können sich die berechneten Emissionen verändern.",
            FLIGHT_WITH_FLIGHT_NUMBER_JOURNEY_WITHOUT_DATES: "Ihre Reise hat keine exakten Daten, ihr ursprünglischer Flug hat jedoch ein Flugdatum. Das Flugdatum wurde automatisch entfernt.",
            CAR_BUS_REDUCED_TO_ONE_DAY: "Ihre ursprüngliche Auto Aktivität hat eine Dauer von mehr als einem Tag. Die Dauer wurde auf einen Tag reduziert.",
            CAR_BUS_ROUTE_REMOVED: "Ihre ursprüngliche Auto Aktivität hat eine Route. Diese wurde entfernt.",
        },
        SETTINGS: {
            ADD_EMAIL: "Bitte E-Mail angeben",
            ADD_FIRST_NAME: "Bitte Vornamen angeben",
            ADD_LAST_NAME: "Bitte Nachnamen angeben",
            NO_EXPEDIENT: "Sie können eine Agentur erstellen, ohne dass Sie dieser Expedient_innen hinzufügen. Sie können Expedient_innen im Nachhinein über die Einstellungen der Agentur hinzufügen.",
            ASPECT_RATIO_LOGO: "Das von Ihnen ausgewählte KlimaLinkLogo hat keine optimalen Dimensionen. Idealerweise ist ihr Agenturlogo quadratisch.",
            IS_ADMIN: "Wenn Sie eine_n Nutzer_in zum Admin machen, kann diese_r Nutzer_innen anlegen und löschen, Informationen der Agentur bearbeiten sowie das Logo der Agentur bearbeiten.",
        },
        FLIGHT: {
            RETURN_FLIGHT_SPLIT: "Der Rückflug wird beim hinzufügen zum Reisetag {{day}} automatisch in zwei Flüge aufgeteilt.",
            RETURN_FLIGHT_FLIGHT_NUMBER: "Der Rückflug hat i.d.R. eine andere Flugnummer. Wenn Sie den Rückflug nicht gesondert angeben, kann dies zu einer ungenaueren Berechnung der Emissionen führen."
        },
    },
    TOASTS: {
        SUCCESS: {
            CAR_DATA_VIA_ACRISS_CODE: "Fahrzeugdaten wurden erfolgreich durch den Acriss-Code ermittelt.",
            CREATE_BUNDLE: "Daten gespeichert.",
            UPDATE_USER_SUCCESS_ADMIN: "Expedient_in erfolgreich bearbeitet.",
            MAKE_USER_AGENCY_ADMIN: "Expedient_in ist nun Agenturadmin.",
            UNMAKE_USER_AGENCY_ADMIN: "Expedient_in ist nicht mehr Agenturadmin.",
            ADD_COMPANY: "Firma erfolgreich hinzugefügt.",
            ADD_AGENCY: "Agentur erfolgreich hinzugefügt.",
            EDIT_AGENCY: "Agentur erfolgreich bearbeitet.",
            EDIT_COMPANY: "Firma erfolgreich bearbeitet.",
            INVITE_COMPANY_ADMIN: "Die E-Mail an den Firmenadmin wurde versandt.",
            INVITE_USER: "Expedient_in erfolgreich eingeladen. Eine E-Mail mit weiteren Informationen wurde versandt.",
            DELETE_USER: "Expedient_in erfolgreich gelöscht.",
            DELETE_AGENCY: "Agentur erfolgreich gelöscht.",
            UPLOAD_AGENCY_LOGO: "Agenturlogo erfolgreich hochgeladen.",
            DELETE_AGENCY_LOGO: "Agenturlogo erfolgreich gelöscht.",
            CHANGE_USERS_AGENCY: "Expedient_in erfolgreich einer anderen Agentur zugeordnet.",
            SEND_PASSWORD_RESET_EMAIL: "Wir haben Ihnen eine E-Mail gesendet. Folgen Sie den Anweisungen in der E-Mail, um ein neues Passwort zu setzen.",
            RESEND_INVITATION_EMAIL: "E-Mail mit Einladungslink wurde erneut an {{email}} gesendet.",
            UPDATE_USER_SELF: "Sie haben Ihre Daten erfolgreich bearbeitet.",
            HOTEL_FOUND_VIA_GIATA_ID: "Hotel mit GIATA-ID gefunden.",
            HOTEL_FOUND_VIA_GIATA_ID_REPLACED_PREVIOUS: "Wir haben Ihre bisherigen Eingaben in Hotel, Land, Stadt und Sterne falls nötig, ersetzt.",
            FLIGHT_NUMBER_REMOVED_DIFFERENT_AIRPORT: "Die Flugnummer für den vorherigen Reiseabschnitt wurde automatisch entfernt, da Ankunfts- und Abflugsflughafen nicht zusammenpassen.",
            REPLACED_AIRPORT_SINGULAR: "Wir haben den zuvor eingebenen Flughafen passend zur Flugnummer und Flugdatum automatisch korrigiert.",
            REPLACED_AIRPORT_PLURAL: "Wir haben einige der zuvor eingebenen Flughäfen passend zur Flugnummer und Flugdatum automatisch korrigiert.",
            GETTING_FLIGHTS_VIA_NUMBER_AND_DATE: "Der Flug wurde gefunden und automatisch ergänzt.",
            UNDO_DELETE_ACTIVITY_FROM_JOURNEY: '{{activity}} wieder zur Reise hinzufügen.',
            UNDO_DELETE_ACTIVITY_FROM_TRAVEL_COMPONENTS_TABLE: '{{activity}} wieder zu Reisebausteinen hinzufügen.',
            UNDO_DELETE_DAY_FROM_JOURNEY: 'Tag {{day}} wieder zur Reise hinzufügen.',
            ACTIVITY_ADDED_TO_TRAVEL_COMPONENTS: '{{activity}} zu Reisebausteinen hinzugefügt.',
            ACTIVITY_ADDED_TO_JOURNEY: '{{activity}} zur Reise hinzugefügt.',
            UPDATE_BUNDLE: "Daten aktualisiert.",
            DELETE_BUNDLE: "Daten gelöscht.",
            TRAVEL_COMPONENTS_COPIED_TO_CLIPBOARD: "Reisebausteine in die Zwischenablage kopiert.",
            JOURNEY_COPIED_TO_CLIPBOARD: "Reise in die Zwischenablage kopiert.",
            DELETE_REMOTE_DATA: "Gespeicherte Daten wurden gelöscht.",
            DELETE_LOCAL_DATA: "Lokale Daten wurden entfernt.",
            DELETE_SELECTED_ACTIVITIES: "Ausgewählte Reisebausteine wurden entfernt.",
            COMPUTED_TOTAL_PASSENGER_COUNT: "Die Gesamtzahl der Fahrgäste in der Buskategorie wurde erfolgreich ermittelt."
        },
        WARNING: {
            NO_ROUTE_FOUND: "Es konnte keine Route gefunden werden.",
            DIFFERENT_CO_2_ON_LOAD_BUNDLE: "Die neuberechneten kg CO₂e Werte (alt gesamt: {{oldCo2KgE}}, neu gesamt: {{newCo2KgE}}) unterscheiden sich von den Werten zum Zeitpunkt des abspeichern der Daten. Um Ihre Daten mit den neuen Daten zu aktualisieren, speichern Sie die Daten bitte erneut ab.",
            ROUTE_TOO_LONG: "Route zu lang. Die maximale Distanz darf {{maxDistance}} nicht überschreiten.",
            MISSING_CUSTOMER: "Wenn Sie weitere Kund_innen Informationen angeben, müssen Sie mindestens einen Vornamen für den_die Kund_in angeben.",
            NAME_TO_SHORT: "Bitte geben Sie einen Namen ein der länger als {{min}} ist.",
            GENERIC_MIN: "Der minimale Wert ist {{min}}.",
            GENERIC_MAX: "Der maximale Wert ist {{max}}.",
            DIFFERENT_FLIGHT_WITH_FLIGHT_NUMBER_CODE_SHARING: "Der Flug mit der Flugnummer {{flightNumber}} und neuem Flugdatum {{flightDate}} ist nun ein Codesharing-Flug, der von einer anderen Airline durchgeführt wird. Deswegen wurde die Flugnummber und das Flugdatum entfernt und die Emissionen ohne Flugnummer und Flugdatum berechnet. Dies kann zu leicht anderen Ergebnissen bei der Berechnung der Emissionen führen.",
            DIFFERENT_FLIGHT_WITH_FLIGHT_NUMBER: 'Der Flug mit der Flugnummer {{flightNumber}} und neuem Flugdatum {{flightDate}} ist eine andere Verbindung ({{legs}}) als Ihr originaler Flug. Deswegen wurde die Flugnummber und das Flugdatum entfernt und die Emissionen ohne Flugnummer und Flugdatum berechnet. Dies kann zu leicht anderen Ergebnissen bei der Berechnung der Emissionen führen.',
            UNDO_DELETE_ACTIVITY_FROM_JOURNEY: "Der Reisebaustein {{activity}} kann nicht mehr zur Reise hinzugefügt werden, da der Tag {{day}} nicht mehr existiert.",
            REMOVED_FLIGHT_NUMBER_ON_RECALCULATION: 'Ein Flug mit der angegebenen Flugnummer {{flightNumber}} kann für den {{date}} nicht gefunden werden. Aus diesem Grund wurde diese Flugnummer entfernt und die Emissionen erneut ohne Flugnummer berechnet. Dies kann zu leicht anderen Ergebnissen bei der Berechnung der Emissionen führen.',
            GETTING_FLIGHTS_VIA_NUMBER_AND_DATE_NO_FLIGHTS_FOUND_NO_AIRPORTS_IN_UI: "Mit dem eingebenen Datum und Flugnummer konnte kein Flug gefunden werden. Bitte geben Abflugs- und Ankunftsflughafen stattdessen ein.",
            GETTING_FLIGHTS_VIA_NUMBER_AND_DATE_NO_FLIGHTS_FOUND_AIRPORTS_IN_UI: "Mit dem eingebenen Datum und Flugnummer konnte kein Flug gefunden werden. Sie können stattdessn mit Start- und Ankunftsflughafen suchen.",
        },
        ERROR: {
            MAPBOX_ADDRESS_TO_LONG: "Die von Ihnen eingegeben Adresse ist zu lang. Bitte geben Sie eine Adresse ein, welche nicht länger als {{maxLength}} Zeichen ist.",
            NO_EMISSION_ON_LOAD: "Es konnten keine Emissionswerte für Ihre Daten berechnet werden. Die Daten wurden dennoch geladen.",
            NO_EMISSION_DATA_AT_ALL_ON_LOAD: "Es konnten keine Emissionswerte für Ihre Daten berechnet werden. Die Daten wurden dennoch geladen. Darüber hinaus gab es keine Emissionswerte in Ihren gespeicherten Daten. Bitte überprüfen Sie ihre Daten.",
            NO_RESULT_FLIGHT_NUMBER_AND_DATE: "Wir konnten nicht verifizieren ob ein Flug mit der Flugnummer {{flightNumber}} und dem neuem Flugdatum {{flightDate}} existiert. Dies kann zu einer falschen Emissionesberechnung führen.",
            ACTIVITY_MOVED_EMISSIONS_NOT_CALCULATED: "Die Emissionen der Aktivität hängen vom Datum der Aktivitätt ab. Für das neue Datum konnten keine Emissionen berechnet werden.",
            READ_BUNDLE: "Daten konnten nicht geladen werden.",
            LOAD_BUNDLE: "Daten konnten nicht geladen werden.",
            CREATE_BUNDLE: "Daten konnten nicht gespeichert.",
            UPDATE_USER_SELF: "Ihre Daten konnten nicht bearbeitet werden.",
            UPDATE_USER_ADMIN: "Expedient_in konnte nicht bearbeitet werden.",
            MAKE_USER_ADMIN: "Expedient_in konnte nicht zum Agenturadmin gemacht werden.",
            UNSET_USER_ADMIN: "Dem_der Expedient_in konnten nicht die Adminrecht entzogen werden.",
            ADD_COMPANY: "Firma konnte nicht hinzugefügt werden, bitte versuchen Sie es erneut.",
            EDIT_COMPANY: "Firma konnte nicht bearbeitet werden.",
            ADD_AGENCY: "Agentur konnte nicht hinzugefügt werden, bitte versuchen Sie es erneut.",
            EDIT_AGENCY: "Agentur konnte nicht bearbeitet werden.",
            INVITE_COMPANY_ADMIN: "Die E-Mail konnte nicht an den Firmenadmin versendet werden.",
            INVITE_COMPANY_ADMIN_ALREADY_MEMBER: 'Expedient_in ist bereits Mitglied der TravelDatabase',
            INVITE_COMPANY_ADMIN_COMPANY_EXISTS: 'Diese Firma exisitiert bereits',
            INVITE_USER: "Einladung konnte nicht gesendet werden.",
            INVITE_USER_DEACTIVATED: "Einladung nicht gesendet. Der_die Expedient_in existiert bereits, aber ist deaktiviert. Bitte kontaktieren Sie den KlimaLink Support.",
            DELETE_USER: "Expedient_in konnte nicht gelöscht werden.",
            DELETE_AGENCY: "Agentur konnte nicht gelöscht werden.",
            UPLOAD_AGENCY_LOGO: "Agenturlogo konnte nicht hochgeladen werden.",
            DELETE_AGENCY_LOGO: "Agenturlogo konnte nicht gelöscht werden.",
            CHANGE_USERS_AGENCY: "Expedient_in konnte nicht der neuen Agentur zugeordnet werden.",
            SEND_PASSWORD_RESET_EMAIL: "E-Mail konnte nicht versendet werden.",
            RESEND_INVITATION_EMAIL: "E-Mail mit Einladungslink konnte nicht erneut an {{email}} gesendet werden.",
            GETTING_FLIGHTS_VIA_NUMBER_AND_DATE: "Da ist etwas schief gegangen. Bitte versuchen es es erneut oder geben Sie statt Flugnummer und Flugdatum den Ablufgs- und Ankunftsflughafen ein.",
            GETTING_FLIGHTS_CODE_SHARING_FLIGHT: "Leider ist dieser Flug ein Codesharing-Flug, der von einer anderen Airline durchgeführt wird. Bitte suchen Sie mit Abflugs- und Ankunftsflughafen oder mit der Flugnummer der durchführenden Airline stattdessen.",
            PARTIAL_OR_COMPLETE_CALCULATION: "Sie können die Serviceleistung dennoch weiterhin verwenden, es wird jedoch kein CO₂ e für diesen Service angezeigt.",
            HOTEL_NIGHTS_EXCEED_JOURNEY_DAYS: "Ihre Reise hat eine Länge von {{days}} Tagen und Sie versuchen den Hotelaufenthalt auf {{nights}} Nächte zu ändern. Bitte verlängern Sie Ihre Reise.",
            NO_AGENCY_PDF: "Sie sind keiner Agentur zugeordnet. Bitte erstellen Sie eine Agentur um ein PDF erstellen zu können.",
            NO_AGENCY_SAVE: "Sie sind keiner Agentur zugeordnet. Bitte erstellen Sie eine Agentur um Ihre Daten zu speichern.",
            UPDATE_BUNDLE: "Daten konnten nicht aktualisiert werden.",
            DELETE_BUNDLE: "Daten konnten nicht gelöscht werden.",
            GET_ADDRESS_WITH_COORDINATES: "Huch... Da ist leider ein technischer Fehler aufgetreten. Bitte versuchen Sie es erneut.",
            GENERAL: 'Huch... leider ist ein technischer Fehler aufgetreten.',
            VALIDATE_ACRISS_CODE: "Acriss-Code konnte nicht validiert werden",
            COMPUTED_TOTAL_PASSENGER_COUNT: "Die Gesamtzahl der Fahrgäste konnte für die Buskategorie nicht berechnet werden.",
            WRONG_ACRISS_CODE: "Ungültiger Acriss-Code",
            CAR_PROPS_ACRISS_CODE: "Fahrzeugdaten konnten nicht mittels Acriss-Code ermittelt werden",
            ROUTE: "Route konnte nicht berechnet werden",
            HOTEL_NOT_FOUND: "Hotel nicht gefunden.",
            LUF_NO_ACCESS_RIGHTS: "Sie haben keine Berechtigung, die Lookup files herunter zu laden.",
            EMISSIONS_NOT_CALCULATED_JOURNEY: 'Die Emissionen für den Reisebaustein {{activityType}} konnten nicht berechnet werden.',
            VEHICLE_TYPE_CAR_NO_DATA: "Bitte geben Sie entweder den Treibstoffverbrauch und/oder die Fahrzeugkategorie und/oder den Acriss Code ein.",
            VEHICLE_TYPE_BUS_NO_DATA: "Bitte geben Sie entweder den Treibstoffverbrauch und/oder die Fahrzeugkategorie ein.",
            VEHICLE_TYPE_BUS_MISSING_DATA: "Bitte geben Sie entweder die Fahrzeugkategorie oder die Gesamtanzahl der Passagiere zusammen mit dem Treibstoffverbrauch ein.",
            FUEL_CONSUMPTION_NO_FUEL_TYPE: "Wenn Sie Treibstoffverbrauch angeben, müssen Sie ebenfalls die Treibstoffart angeben.",
            DELETE_REMOTE_DATA: "Gespeicherte Daten konnten nicht gelöscht werden.",
            GET_ROUTE_FROM_COORDINATES: "Route konnte nicht gefunden werden.",
            USER_EXISTS: "Ein_e Expedient_in mit diesem E-Mail-Adresse existiert bereits.",
            TOO_MANY_AGENCIES_INVITATION: "Einladungs E-Mail an {{email}} konnte nicht erneut versendet werden, da Expedient_in in mehr als einer Agentur ist.",
        }
    },
    LABELS: {
        TRAVEL_COMPONENTS: {
            GENERAL_INFORMATION_ON_FORM: "Reisebausteine speichern Dialog",
            INFORMATION: 'Information um Reisebaustein zu speichern',
            SELECT_TRAVEL_COMPONENT: "Ausgewählter Reisebaustein",
            UPDATE_OR_SAVE_TRAVEL_COMPONENTS: "Reisebausteine aktualisieren oder neu abspeichern",
            ADD_TO_JOURNEY: "{{activity}} zur Reise hinzufügen"
        },
        CUSTOMER: {
            GENERAL_CUSTOMER_INFORMATION: "Optionale allgemeine Kund_innen Informationen",
            DETAILED_CUSTOMER_INFORMATION: "Optionale detaillierte Kund_innen Informationen (bearbeiten oder neu)"
        },
        SETTINGS: {
            KLIMALINK_ADMINISTRATION: "Klimalink Einstellungen: Neuen Firmenadmin einladen",
            TAC_CHECKBOX: "Ich akzeptiere die allgemeinen Geschäftsbedingungen",
            CREATE_AGENCY: "Eine neue Agentur anlegen",
            CREATE_COMPANY: "Eine neue Firma anlegen",
            AGENCY_NAME_AND_EMAIL: "Agenturname und Agenturemail",
            COMPANY_NAME_AND_EMAIL: "Firmenname und Firmenemail",
            IS_MEMBER: "Ist KlimaLink Mitglied?",
            CHOOSE_USERS_AGENCY: "Users agency",
            CHOOSE_USERS_AGENCY_ADMIN: "Agency where user is admin",
        },
        JOURNEY: {
            GENERAL_INFORMATION_ON_FORM: "Reise anlegen Dialog",
            INFORMATION: 'Informationen eingeben um Reise an zu legen',
            CREATE_JOURNEY: 'Reisebausteine Tagen zurodnen',
            NUMBER_NIGHTS: "Number of nights",
            UPDATE_OR_SAVE_JOURNEY: "Reise aktualisieren oder neu abspeichern",
        },
        FLIGHT: {
            NUMBER_FLIGHT_PERSONS_RETURN: 'Anzahl der Flüge, Anzahl der Personen, Rückflug Ja/Nein',
        },
        COMMON: {
            NUMBER_PERSONS: "Anzahl der Personen",
            NUMBER_NIGHTS: 'Anzahl der Nächte',
            NUMBER_DAYS: 'Anzahl der Tage',
            ADD_ACTIVITY: "Reisebaustein hinzufügen",
            BUNDLE_SAVE: "Neu abspeichern",
            BUNDLE_UPDATE: "Vorhandene Daten aktualisieren",
            SELECT_AGENCY: "Agentur auswählen"
        },
        HOTEL: {
            MEAL_PLAN: 'Bitte wählen Sie die Art und Weise der Verpflegung aus.',
        },
        CAR_BUS: {
            HYBRID: "Hybrid",
            FIRST_WAYPOINT: "Start",
            LAST_WAYPOINT: "Ziel",
            WAYPOINT: "Zwischenstopp",
            VEHICLE_TYPE: "Fahrzeugtyp",
            FUEL_TYPE: "Treibstoffart",
            FUEL_CONSUMPTION: "Treibstoffverbrauch ({{unit}})",
            ACRISS_CODE: "Acriss Code",
            FIRST_LAST_CHARACTER: "Nur erster & letzter Buchstabe",
            COUNT_DAYS: "Tage",
            COUNT_PERSONS: "Personen",
            TOTAL_PASSENGER_COUNT: "Gesamtanzahl der Passagiere",
            DISTANCE_KM: "Distanz (km)",
            ENTER_CAR_AND_ROUTE_INFORMATION: "Fahrzeug- und Routeninformationen eintragen",
            CAR_BUS_CATEGORY: "Fahrzeugkategorie",
            DAYS_OF_USE_NUMBER_PASSENGERS: "Tage der Nutzung, Anzahl der Personen",
            MAP_STYLE: "Kartenstil",
        }
    },
    TOOLTIP: {
        TRAVEL_COMPONENTS: {
            DELETE_REMOTE_DATA: "Gespeicherte Reisebausteine dauerhaft löschen",
            EDIT_CUSTOMER_INFORMATION: "Kund_innen Informationen bearbeiten",
            SAVE_TRAVEL_COMPONENTS: "Reisebausteine abspeichern",
            LOAD_TRAVEL_COMPONENTS: "Reisebausteine laden",
            ADD_TO_JOURNEY: "Zur Reise hinzufügen",
            CLEAR_TABLE: "Reisebausteinetabelle leeren",
            DELETE_SELECTED_ACTIVITIES: "Ausgewählte Reisebausteine löschen"
        },
        FLIGHT: {
            MAX_STOPOVERS: "Sie können nicht mehr als {{maxStopovers}} Flughäfen anfliegen.",
            REMOVE_STOPOVER: "Stopover entfernen"
        },
        SETTINGS: {
            IS_ADMIN: "Wenn Sie eine_n Nutzer_in zum Admin machen, kann diese_r Nutzer_innen anlegen und löschen, Informationen der Agentur bearbeiten sowie das Logo der Agentur bearbeiten.",
            RESEND_INVITATION_EMAIL: "Einladungsemail erneut an {{email}} senden.",
            CHANGE_PASSWORD: "Wir haben eine E-Mail an Ihre hinterlegte Emailadresse mit Anweisung zum Ändern Ihres Passwortes geschickt",
            MAKE_ADMIN: "Zum Agenturadmin machen",
            MAKE_ADMIN_KLIMALINK: "Zum Agenturadmin der von Agentur {{agency}} machen",
            REMOVE_ADMIN: "Agentur-Adminrecht entziehen",
            REMOVE_ADMIN_KLIMALINK: "Agentur-Adminrecht für Agentur {{agency}} entziehen",
            RESEND_INVITATION_EMAIL_ALREADY_REGISTERED: "Expedient_in hat bereits den Registrierungsprozess abgeschlossen. Eine erneute Einladung ist nicht mehr erforderlich.",
            EDIT_USER: "Expedient_in bearbeiten",
            EDIT_AGENCY: "Agentur bearbeiten",
            DELETE_AGENCY: "Agentur löschen",
            DELETE_USER: "Expedient_in löschen",
            DELETE_COMPANY: "Firma löschen",
            EDIT_COMPANY: "Firma bearbeiten",
            CHANGE_USERS_AGENCY: "Agenturzugehörigkeit ändern",
            EDIT_OTHER_ADMIN: "Ein anderer Agenturadmin kann nur von einem Company Admin bearbeitet werden.",
            DELETE_OTHER_ADMIN: "Ein anderer Agenturadmin kann nur von einem Company Admin gelöscht werden.",
            CHANGE_AGENCY_OTHER_ADMIN: "Ein Agenturadmin kann nicht einer anderern Agentur zugeordnet werden.",
            UNMAKE_OTHER_AGENCY_ADMIN: "Ein Agenturadmin kann nur von einem Company Admin zu einem 'normalen' Agenturmitglied gemacht werden. ",
            MAKE_AGENCY_ADMIN_COMPANY_ADMIN: "Nur Company Admins können Expedient_innen zu Agenturadmins machen.",
            CHANGE_AGENCY_IS_AGENCY_ADMIN: "Expedient_in ist Agenturadmin. Wenn Sie die Agenturzugehörigkeit ändern wollen, entziehen Sie vorher die Adminrechte.",
            CHANGE_AGENCY_IS_COMPANY_ADMIN: "Expedient_in ist Firmenadmin. Firmenadmins sind jeder Agentur automatisch zugehörig.",
            CHANGE_AGENCY_ADMIN_IS_COMPANY_ADMIN: "Expedient_in ist Firmenadmins. Firmenadmins sind automatisch Agenturadmins.",
            DELETE_KLIMALINK_ADMIN: "KlimaLink Admins können nicht gelöscht werden.",
            CHANGE_AGENCY_KLIMALINK_ADMIN: "KlimaLink Admins können keiner anderen Agentur zugeordnet werden.",
            MAKE_UNMAKE_AGENCY_ADMIN_KLIMALINK: "Agentur-Adminrechte können KlimaLink Admins nicht entzogen werden.",
            MAKE_UNMAKE_AGENCY_ADMIN_COMPANY_ADMIN: "Firmen Admins können Agentur-Adminrechte nicht entzogen werden, da sie automatisch Firmenadmins sind.",
            DELETE_COMPANY_ADMIN: "Company Admin löschen. Damit werden alle Agenturen und Expedient_innen, welcher der Firma angehören, ebenfalls gelöscht. Die Daten bleiben jedoch erhalten.",
            CHANGE_USERS_AGENCY_NOT_POSSIBLE_COMPANY_ADMIN: "Agenturzugehörigkeit kann nicht geändert werden, da der_die Expedient_in Firmenadmin ist. Firmenadmins sind Mitglied in jeder Agentur.",
            CANNOT_INVITE_USERS_ON_NOT_PRODUCTION: "Neue Mitglieder können nur auf der Produktivinstanz eingeladen werden.",
            INVITE_USERS_ON_STAGING: "Neue Mitglieder können nur auf der Produktivinstanz (https://b2b.klimalink.org/travel-database) eingeladen werden. Es kann einige Minuten dauern, bis das neue Mitglied die Testinstanz (https://b2b.dev.klimalink.org/travel-database) nutzen kann.",
            CANNOT_CREATE_AGENCIES_ON_NOT_PRODUCTION: "Neue Agenturen können nur auf der Produktivinstanz (https://b2b.klimalink.org/travel-database) angelegt werden. Es kann einige Minuten dauern, bis die neue Agentur auf der Testinstanz (https://b2b.dev.klimalink.org/travel-database) verfügbar ist.",
            CREATE_AGENCIES_ON_STAGING: "Neue Agenturen die auf der Testinstanz angelegt werden, sind nicht auf der Produktivinstanz verfügbar.",
            EDIT_PERSONAL_DATA: "Persönliche Daten bearbeiten",
            USER_DEACTIVATED: "Diese_r Expedient_in ist deaktiviert.",
            EDIT_GENERAL_ON_STAGING: "Änderungen die Sie hier vornehmen werden nicht auf der Produktivinstanz wirksam.",
        },
        COMMON: {
            DISABLED_FUNCTIONALITY_DEV_INSTANCE: "Diese Funktion is nur auf der Produktivinstanz verfügbar.",
            MAINTENANCE: "Derzeit deaktiviert aufgrund von Wartungsarbeiten",
            CREATE_AGENCY_PDF: "Bitte erstellen Sie eine Agentur um ein PDF zu exportieren",
            CRETE_AGENCY_SAVE_BUNDLE: "Bitte erstellen Sie eine Agentur um Ihre Daten speichern können",
            DELETE_LOCAL_DATA: "Daten nur lokal löschen",
            EDIT_TRAVEL_COMPONENT: "Reisebaustein bearbeiten",
            NO_TRAVEL_COMPONENTS: "Bisher keine Reisebausteine vorhanden",
            COUNT_TRAVEL_COMPONENTS_SINGULAR: "{{count}} Reisebaustein vorhanden",
            COUNT_TRAVEL_COMPONENTS_PLURAL: "{{count}} Reisebausteine vorhanden",
            COUNT_DAYS_SINGULAR: "{{count}} Tag in Reise",
            COUNT_DAYS_PLURAL: "{{count}} Tage in Reise",
            NO_DATA_JOURNEY: "Bisher keine Reisebausteine in Reise",
            BETA: "Dies ist eine Betaversion. Manche Funktionalitäten können fehlerhaft sein. Darüber hinaus können berechnete Emissionswerte falsch sein! Falls Sie Feedback und Anregung haben, schicken Sie dieses bitte an info@klimalink.org.",
            MOVE_ONE_DAY_DOWN: "Reisebaustein einen Tag nach unten bewegen",
            MOVE_ONE_DAY_UP: "Reisebaustein einen Tag nach oben bewegen",
            MOVE_ALT_KEY: 'Alt-Taste gedrückt halten um einen Reisebausteine aus der Gruppe zu bewegen.',
            DELETE_ALT_KEY: 'Alt-Taste gedrückt halten um einen Reisebaustein aus der Gruppe zu löschen.',
            EDIT_ALT_KEY: 'Alt-Taste gedrückt halten um einen Reisebausteine aus der Gruppe zu bearbeiten.',
            DELETE_TRAVEL_COMPONENT: "Reisebaustein löschen",
            DRAG_AND_DROP: "Reisebaustein mit Drag and Drop bewegen",
            CREATE_PDF: "PDF erstellen",
            COPY_JOURNEY_TO_CLIPBOARD: "Reise in die Zwischenablage kopieren",
            COPY_TRAVEL_COMPONENTS_TO_CLIPBOARD: "Reisebausteine in die Zwischenabalage kopieren",
            CALENDAR_DEACTIVATED_JOURNEY_NO_DATES: "Sie können kein Datum auswählen, da Ihre Reise kein exaktes Datum hat"
        },
        ACTIVITY_FLIGHT: {
            REMOVE_STOPOVER: "Stopover entfernen",
            RETURN_FLIGHT: "Rückflug",
            ROUNDTRIP_SINGULAR: "Hin- und Rückflug",
            ADD_STOPOVER_DISABLED_EDIT: "Sie können keinen Zwischenstop hinzufügen, wenn sie einen Flug editieren",
            REMOVE_STOPOVER_DISABLED_EDIT: "Sie können keinen Zwischenstop entfernen, wenn sie einen Flug editieren",
            OWN_AIRPORT_TRANSFER_DISABLED_EDIT: "Sie können diesen Werte nicht editieren, wenn sie einen Flug editieren"

        },
        ACTIVITY_HOTEL: {
            CHOOSE_DATES: "Datum auswählen",
        },
        JOURNEY: {
            DELETE_REMOTE_DATA: "Gespeicherte Reise dauerhaft löschen",
            GROUP_DURATION: "{{activity}} an Tag {{days}}",
            MOVE_CAR_BUS_ACTIVITY_WITH_ROUTE: "Dieser Auto Reisebaustein hat eine Route und ist länger als einen Tag. Deswegen kann er nur als Gruppe bewegt werden.",
            DELETE_DAY: "Tag löschen",
            ADD_DAY: "Tag hinzufügen",
            SAVE_JOURNEY: "Reise speichern",
            LOAD_JOURNEY: "Reise laden",
            MOVE_DAY_UP: "Tag nach oben bewegen",
            CALCULATE_NEW_ACTIVITY: "Neuen Reisebaustein berechnen",
            ADD_ACTIVITY_FROM_TRAVEL_COMPONENT_TABLE: "Reisebaustein von Reisebausteintabelle hinzufügen",
            MOVE_DAY_DOWN: "Tag nach unten bewegen",
            REMOVE_EXACT_DATES: "Genaues Datum von Reise entfernen",
            MOVE_WHOLE_GROUP: "Sie bewegen die gesamte Gruppe von {{activityType}}",
            DELETE_WHOLE_GROUP: "Sie löschen die gesamte Gruppe von {{activityType}}",
            EDIT_WHOLE_GROUP: "Sie editieren die gesamte Gruppe von {{activityType}}",
            CHANGE_JOURNEY_DURATION_BLOCKED_DELETE_DAY: "Die Dauer einer Reise kann nicht verändert werden, während ein Tag gelöscht wird. Bitte warten Sie, bis die 'Tag wieder hinzufügen' Nachricht verschwunden ist.",
            ARROW_GROUP_EXCEEDS_JOURNEY_DURATION: "Gruppe von {{activity}} kann nicht bewegt werden, da sie die Reisedauer über- oder unterschreiten würden.",
            ARROW_ACTIVITY_EXCEEDS_JOURNEY_DURATION: "Reisebaustein {{activity}} kann nicht bewegt werden, da es die Reisedauer über- oder unterschreiten würden.",
            ALT_KEY_PRESSED_MOVE_ELEMENT_FROM_GROUP: "{{activity}} aus Gruppe bewegen",
            ALT_KEY_PRESSED_DELETE_GROUP: "Gesamte Gruppe von {{activity}} löschen",
            ALT_KEY_PRESSED_EDIT_GROUP: "Gesamte Gruppe von {{activity}} bearbeiten",
            DELETE_CAR_BUS_ROUTE_GROUP: "Auto kann nur in gesamter Gruppe gelöscht werden, da es eine Route hat.",
            EDIT_CAR_BUS_ROUTE_GROUP: "Auto kann nur in gesamter Gruppe bearbeitet werden, da es eine Route hat.",
            CLEAR_JOURNEY: "Reise leeren",
        },
        SITE_TITLE: {
            DELETE_CUSTOMER: "Kund_in löschen"
        },
        CAR_BUS: {
            PERSON_COUNT_CALCULATION_HINT: "Anzahl der Personen, für welche die Emissionsn berechnet werden",
            TOTAL_PASSENGER_COUNT: "Gesamtanzahl der Passagiere, welche im Bus mitgefahren sind",
            MAX_NUMBER_WAYPOINTS: "Sie haben die maximale Zahl von {{maxNumber}} Stops erreicht",
            DELETE_WAYPOINT: "Zwischenstop löschen",
            REMOVE_ADDRESS: "Adresse löschen",
            SELECT_STOP_FROM_MAP: "Stop über Karte auswählen",
            CALCULATED_DISTANCE_OVERWRITTEN: "Sie haben eine Distanz manuell eingegeben. Damit überschreiben Sie die Distanz, welche mittels der eingegebenen Route berechnet wurde.",
            IS_HYBRID_DEACTIVATED_ACRISS_CODE: "Sie haben einen Acriss Code eingegeben welcher ein hybrides Fahrzeug ist. Sie können diese Auswahl nicht verändern.",
            IS_HYBRID_DEACTIVATED_FUEL_TYPE: "Sie haben elektrisch als Treibstoffart ausgewählt. Sie können diese Auswahl nicht verändern.",
        },
    },
    NAVIGATION: {
        STATISTIC: "Statistik",
        JOURNEYS: "Reisen",
        HOME: "CO₂e berechnen",
        JOURNEY: "Reise",
        TRAVEL_COMPONENTS: "Reisebausteine",
        ADMINISTRATION: "Administration",
        SETTINGS: "Einstellungen",
        LOGO_ALT: "KlimaLinkLogo der Firma"
    },
    SCREENS: {
        HELP: {
            TITLE: "Hier wird Ihnen geholfen!",
            IFRAME_TITLE: "Anleitung zur B2B Platform",
        },
        JOURNEY: {
            NAME: "Name der Reise",
            INITIAL_GROUP_TITLE: "Alle Reisebausteine",
            NO_DAY_TEXT: 'Sie haben bisher noch keinen Tag in Ihrer Reise',
            ADD_DAY_BUTTON: "Tag hinzufügen",
            ACTIVITY_EXCEEDS_JOURNEY_DURATION: "Reisebausteindauer überschreitet Reisedauer",
            ACTIVITY_PERSON_COUNT_EXCEEDS_JOURNEY_PERSON_COUNT: "Personenanzahl überschreitet Reiseteilnehmer:innen",
        },
        CREATE_AGENCY_INVITE_USERS: {
            COMPLETE_FAIL_INVITE_USER: 'Expedient_innen konnten nicht eingeladen werden. Keine Sorge, Sie können Expedient_innen unter dem Menüpunkt "Einstellungen" einladen.',
            INVITE_USERS: {
                HEADLINE: "Expedient_innen einladen",
                ADD_EXPEDIENT_BUTTON: 'Weitere_n Expedient_in hinzufügen',
                REMOVE_EXPEDIENT_BUTTON: 'Expedient_in entfernen',
            }
        },
        TERMS_AND_CONDITIONS: {
            COMPANY_ADMIN: {
                TITLE_WITH_ACCEPT: "Bitte akzeptieren Sie unsere allgemeinen Geschäftsbedingungen",
                TITLE_WITHOUT_ACCEPT: "Unsere allgemeinen Geschäftsbedingungen",
            },
            NORMAL_USER: {
                TITLE: 'Allgemeine Geschäftsbedingungen',
                HINT: 'Sie können die Travel Database von KlimaLink derzeit nicht nutzen, da ihr Firmen-Admin die Allgemeinen Geschäftsbedingungen noch nicht akzeptiert hat.'
            },
        },
        NO_ROUTE: {
            TITLE: 'Huch, hier gibt es nix zu sehen...'
        },
        REGISTRATION: {
            REGISTRATION_COMPLETE_MESSAGE: "Registrierung erfolgreich",
            CREATING_AGENCY_MESSAGE: "Agentur wird erstellt...",
            INVITING_USERS_MESSAGE: "Einladungsemail wird an Expedient_innen versandt...",
            COMPANY_USER_TITLE: 'Bitte vervollständigen Sie Ihre Daten, um die Registrierung bei KlimaLink, der Travel Footprint Database, ab zu schließen',
            AGENCY_USER_TITLE: "Bitte legen Sie eine Agentur an und laden Sie Expedient_innen ein",
            GIVEN_INFORMATION_TITLE: "Bereits angelegte Informationen",
            MISSING_USER_INFORMATION_TITLE: "Bitte ergänzen Sie die fehlende Nutzer_innen Informationen für {{userName}} ({{email}})",
            COMPANY_ADMIN: {
                MISSING_COMPANY_INFORMATION_TITLE: "Bitte ergänzen Sie die Fehlende Firmeninformationen für {{company}} ergänzen",
            },
        },
        SETTINGS: {
            MENU: {
                ADMIN_SETTINGS: "Admin Einstellungen",
                USER_SETTINGS: "Persönliche Einstellungen",
                KLIMALINK_SETTINGS: "KlimaLink Einstellungen",
            },
            SEARCH_BAR_LABEL_MEMBERS: "Nach Expedient_innen suchen (Suche mit Nachnamen von Expedient_innen möglich)",
            SEARCH_BAR_LABEL_MEMBERS_AGENCIES: "Nach Agenturen suchen (keine Suche mit Vor- oder Nachnamen von Expedient_innen möglich)",
            SEARCH_BAR_LABEL_AGENCIES: "Nach Agenturen suchen (keine Suche mit Firmennamen möglich)",
            NO_AGENCY_HINT_ADD_USERS: "Bitte legen Sie eine Agentur an. Erst dann können Sie Expedient_innen hinzufügen.",
            NO_AGENCY_HINT_ADD_LOGO: "Bitte legen Sie eine Agentur an. Erst dann können Sie ein Agenturlogo hochladen.",
            NO_AGENCY_HINT_USER_SETTINGS: "Bisher sind sie noch keiner Agentur zugehörig.",
            INVITE_COMPANY_ADMIN: "Firmenadmin zu KlimaLink einladen",
            AMI_I_AGENCY_ADMIN: "Bin ich Agenturadmin?",
            TITLE: "Einstellungen",
            PERSONAL_DATA: "Persönliche Daten",
            USER_SETTINGS_AGENCY_TITLE: "Agentur, der ich zugeordnet bin",
            USER_SETTINGS_AGENCIES_TITLE: "Meine Agenturen",
            DELETE_USER: "Expedient_in {{user}} löschen?",
            DELETE_USER_TEXT: "Möchten Sie {{user}} wirklich löschen? {{user}} kann dann nicht mehr die Travel Footprint Database von KlimaLink verwenden. Die von {{user}} gespeicherten Daten bleiben jedoch erhalten.",
            DELETE_USER_KLIMALINK_TEXT: "Möchten Sie {{user}} wirklich löschen? {{user}} kann dann nicht mehr die Travel Footprint Database von KlimaLink verwenden. Die von {{user}} gespeicherten Daten bleiben jedoch erhalten. {{user}} ist in den folgenden Agenturen: {{agencies}}.",
            DELETE_COMPANY_ADMIN_KLIMALINK_TEXT: "{{user}} ist ein Firmen Admin.",
            DELETE_AGENCY_TEXT: "Möchten Sie {{agency}} wirklich löschen? Alle zu {{agency}} zugehörigen Expedient_innen werden ebenfalls gelöscht. Alle Daten, welche die Expedient_innen von {{agency}} gespeichert haben werden ebenfalls gelöscht.",
            DELETE_OWN_AGENCY_TEXT: "Da Sie die Agentur löschen der Sie ebenfalls angehören, wird Ihr Account ebenfalls gelöscht.",
            DELETE_COMPANY_TEXT: "Möchten Sie {{company}} wirklich löschen? Alle zu {{company}} zugehörigen Agenturen und Expedient_innen werden ebenfalls gelöscht. Alle Daten, welche die Expedient_innen von {{company}} gespeichert haben werden ebenfalls gelöscht. Ihr eigener Account wird ebenfalls gelöscht.",
            DELETE_AGENCY: "Agentur {{name}} löschen",
            DELETE_COMPANY: "Firma {{name}} löschen",
            CHANGE_PASSWORD_LABEL: "Passwort ändern",
            CHANGE_PASSWORD_REQUEST_EMAIL: "E-Mail erhalten",
            CHANGE_PASSWORD_EMAIL_SEND: "E-Mail gesendet",
            EDIT_USER: "Expedient_in bearbeiten {{name}}",
            EDIT_USER_PERSONAL: "Persönliche Daten bearbeiten",
            ADD_NEW_USER: "Expedient_in anlegen",
            ADD_NEW_AGENCY: "Agentur anlegen",
            ADD_NEW_COMPANY: "Firma anlegen",
            ADD_NEW_USER_FAIL: "Expedient_in konnte nicht hinzugefügt werden.",
            COMPANY_TITLE: "Firma",
            AGENCIES_TITLE: "Agenturen",
            USERS_TITLE: "Expedient_innen",
            EDIT_AGENCY: "Agentur bearbeiten",
            EDIT_COMPANY: "Firma bearbeiten",
            AGENCY_NAME_ALREADY_GIVEN: "Der Agenturname {{agencyName}} wird bereits verwendet. Bitte verwenden sie einen anderen.",
            INVITE_CONTACT_PERSON_FAIL: 'Eine Ihrer Kontaktpersonen konnte nicht zur Travel Footprint Database hinzugefügt werden',
            ADD_LOGO: "Agenturlogo",
            ADD_LOGOS: "Agenturlogos",
            NO_LOGO_UPLOADED_YET: "Kein KlimaLinkLogo bisher hochgeladen.",
            LOGO_UPLOADED_SUCCESS: "Folgende Datei hochgeladen",
            FILE_NAME: "Dateiname",
            DROP_LOGO_HOVER: "KlimaLinkLogo hier ablegen",
            DROP_LOGO_TEXT: "Datei hochladen oder per Drag & Drop reinziehen. Idealerweise 200x200px.",
            USERS_COUNT: "Anzahl Expedient_innen",
            IS_ADMIN_LABEL: "Agenturadmin",
            INVITE_CONTACT_PERSON: 'Möchten Sie den_die {{contactPerson}} zur Travel Footprint Database einladen?',
            MAKE_CONTACT_PERSON_AGENCY_ADMIN: 'Möchten Sie den_die {{contactPerson}} zum Agenturadmin machen?',
            ADD_USER_EMAIL_ALREADY_IN_USE: "Expedient_in kann nicht hinzugefügt werden. Die Emailadresse ({{email}}) wird bereits verwendet.",
            USER_REGISTRATION_NOT_COMPLETED: "Registrierung noch nicht abgeschlossen.",
            ADD_SECOND_CONTACT: 'Weitere_n Ansprechpartner_in hinzufügen',
            USER_PREFERENCES: {
                TITLE: "Personalisierung",
                SHOW_GIATA_ID_FIELD_TEXT: "Möchten Sie bei der Hotelsuche die Möglichkeit haben, mit einer GIATA-ID zu suchen?",
                SHOW_GIATA_ID_FIELD_LABEL: "GIATA-ID Feld anzeigen",
            },
        },
        COMMON: {
            GO_TO_TRAVEL_COMPONENTS: "Zu Reisebausteinen",
            GO_TO_JOURNEY: "Zur Reise",
            ADD_ACTIVITY_TO_JOURNEY: "{{activity}} zur Reise an Tag {{day}} hinzufügen",
            ADD_ACTIVITY_TO_TRAVEL_COMPONENTS_TABLE: '{{activity}} zur Reisebausteinetabelle hinzufügen',
            BUTTON_BOTTOM_ACTIVITY: {
                SECOND_BUTTON_ADD: "Zu {{type}} hinzufügen, anderen abfragen",
                SECOND_BUTTON_UPDATE: "In {{type}} aktualisieren, anderen abfragen",
                THIRD_BUTTON_ADD: "Zu {{type}} hinzufügen",
                THIRD_BUTTON_UPDATE: "In {{type}} aktualisieren",
                FOURTH_BUTTON_ADD: "Zu {{type}} hinzufügen, erneut abfragen",
                FOURTH_BUTTON_UPDATE: "In {{type}} aktualisieren, erneut abfragen",
            }
        },
        AUTHENTICATING_USER: {
            TEXT: "KLimaLink authentifiziert Sie..."
        },
        HOME: {
            SITE_TITLE: "Willkommen {{name}} in der Travel Footprint Database",
        },
        SELECT_TRAVEL_COMPONENTS: {
            SITE_TITLE: "Reisebausteine abfragen",
            SEARCH_BAR_LABEL: "Reisebausteine suchen"
        },
        CREATE_JOURNEY: {
            SITE_TITLE: "Reise anlegen",
            JOURNEY_NUMBER: "Reisenummer",
            NO_AGENCY: "Um eine Reise anlegen zu können, müssen Sie eine Agentur erstellt haben."
        },
        HOTEL: {
            HOTEL_INFO: "Hotelinformationen",
            STAY_INFO: "Aufenthaltsinformationen",
            GIATA_ID: "Giata-ID",
            SEARCH: "Hotel suchen",
            HOTEL_NAME: "Hotelname",
            SEARCH_HOTEL_NAME: "Opseational",
            PROPERTY: "Eigentum",
            CITY: "Stadt",
            SEARCH_CITY: "Stadt",
            REGION: "Region",
            COUNTRY: "Land",
            SEARCH_COUNTRY: "Land",
            ROOM_CATEGORY: "Zimmerkategorie",
            ROOM_CATEGORY_SS: "EZ",
            ROOM_CATEGORY_DS: "DZ",
            ROOM_CATEGORY_SP: "EZKomf",
            ROOM_CATEGORY_DP: "DZKomf",
            ROOM_CATEGORY_S: "Suite",
            ROOMS: "Zimmer",
            MEAL_PLAN: "Verpflegungsplan",
            MEAL_CLASS_OV: "OV",
            MEAL_CLASS_ÜF: "ÜF",
            MEAL_CLASS_HP: "HP",
            MEAL_CLASS_VP: "VP",
            MEAL_CLASS_AI: "AI",
            PEOPLE: "Personen",
            NIGHTS: "Nächte",
        },
        TRAVEL_OPTIONS_OVERVIEW: {
            SITE_TITLE: "Reisebausteine",
            ADD: "Weitere Reisebausteine hinzufügen"
        },
        TRAVEL_COMPONENTS_OVERVIEW: {
            CREATE_JOURNEY: "Reise erstellen",
            LOAD_TRAVEL_COMPONENTS: "Reisebausteine laden",
            RADIO_BUTTON_GROUP: "Agentur auswählen",
            ADD_TRAVEL_COMPONENTS: "Reisebausteine hinzufügen",
            NO_TRAVEL_COMPONENTS: "Sie haben bisher noch keine Reisebausteine hinzugefügt.",
            ROOM: "Zimmer",
            ROOMS: "Zimmer",
            NIGHT: "Nacht",
            NIGHTS: "Nächte",
        },
        CAR_BUS: {
            SELECT_VEHICLE_TYPE: "Bitte wählen Sie einen Fahrzeugtyp aus um Fahrzeuginformationen fest zu legen.",
            CAR_INFORMATION: "Fahrzeuginformationen",
            ADD_STOPOVER: "Zwischenstop hinzufügen",
            ROUTE: "Route",
            NO_ADDRESS_REVERSE_GEOCODING: "Keine Addresse gefunden, Koordinaten werden verwendet",
            STREET: "Strasse",
            SATELLITE: "Satellit",
            OUTDOOR: "Outdoor",
            MAP_STYLE: "Kartenstil",
        }
    },
    ALT: {
        KLIMALINK_LOGO: "Das KlimaLink Logo. Ein Bild mit den Wörtern: KlimaLink - Travel Footprint Database",
        ATMOSFAIR_LOGO: "Das atmosfair Logo. Ein Bild mit den Wörtern: atmofair - nachdenken, klimabewusst reisen."
    },
    MODALS: {
        READ_BUNDLES: {
            UPDATING_PERSISTED_DATA_MOCK: "... Aktualisieren Ihrer Daten mit unseren aktuellsten Daten ...",
            CALCULATING_EMISSIONS_MOCK: "... Neuberechnung der Emissionen mit aktualisierten Daten ...",
            TITLE_TRAVEL_COMPONENTS: "Reisebausteine laden",
            TITLE_TRAVEL_JOURNEY: "Reise laden",
            NO_RECORDS: "Für diese Agentur sind keine Datensätze vorhanden",
            AGENCY_SELECTION_MESSAGE: "Wählen Sie eine Agentur aus, um Datensätze anzuzeigen",
            NO_AGENCY: "Sie sind keiner Agentur zugeordnet. Bitte erstellen Sie eine Agentur um ein {{whatToLoad}} laden zu können.",
        },
        REPLACE_OR_ATTACH_TRAVEL_COMPONENTS: {
            TITLE: "Reisebausteine ersetzen oder anhängen",
            TEXT: "Sie haben bereits Reisebausteine in deiner Tabelle für Reisebausteine und laden weitere Reisebausteine. Möchten Sie die bereits vorhandenen Reisebausteine durch die geladenen Reisebausteine ersetzen oder möchten Sie die geladenen Reisebausteine an die bestehenden Reisebausteine anhängen?"
        },
        REPLACE_JOURNEY: {
            TITLE: "Reise ersetzen",
            TEXT: "Sie haben bereits eine Reise mit Reisebausteinen und/oder anderen reisepezifischen Daten. Möchten Sie die bereits vorhandene Reise durch die geladene Reise ersetzen?",
        },
        SAVE_BUNDLES: {
            ADDITIONAL_CUSTOMER_INFORMATION: "Weitere Kund_innen Informationen",
            SAVE_TRAVEL_COMPONENTS_TITLE: "Reisebausteine speichern",
            UPDATE_TRAVEL_COMPONENTS_TITLE: "Reisebausteine aktualisieren",
            SAVE_JOURNEY_TITLE: "Reise speichern",
            UPDATE_JOURNEY_TITLE: "Reise aktualisieren",
            TRAVEL_COMPONENTS_TO_SAVE: 'Zu speicherende Reisebausteine',
            CUSTOMER_OVERLAY_NO_AGENCY_SELECTED: 'Bitte wählen Sie zuerst eine Agentur aus, bevor sie Kund_innen Informationen eintragen können.',
            CUSTOMER_OVERLAY_NO_AGENCY_CREATED: 'Bitte erstellen Sie zuerst eine Agentur, bevor sie Kund_innen Informationen eintragen können.',

        },
        CREATE_JOURNEY: {
            TITLE: "Reise erstellen",
        },
        TRAVEL_COMPONENTS: {
            TITLE: "Bitte Agentur auswählen",
            TEXT: "Sie sind mehreren Agenturen zugeordnet. Bitte wählen Sie die Agentur aus, mit welcher Sie das PDF signieren möchten.",
        },
        DELETE_BUNDLE: {
            JOURNEY_TITLE: "Reise löschen",
            TRAVEL_COMPONENTS_TITLE: "Reisebausteine löschen",
            JOURNEY_TEXT: "Möchten Sie wirklich die Reise ({{name}}), erstellt von {{userName}} löschen? Dies kann nicht rückgängig gemacht werden.",
            TRAVEL_COMPONENTS_TEXT: "Möchten Sie wirklich die Reisebausteine ({{name}}), erstellt von {{userName}} löschen? Dies kann nicht rückgängig gemacht werden."
        },
        SETTINGS: {
            MAKE_ADMIN_TITLE: "{{user}} zum Agenturadmin machen",
            UNMAKE_ADMIN_TITLE: "{{user}} Agentur-Adminrechte entziehen",
            MAKE_UNMAKE_ADMIN_IS_ADMIN_TEXT: "{{user}} ist derzeit Agenturadmin in Agentur {{agency}}.",
            MAKE_UNMAKE_ADMIN_TITLE: "{{user}} Agentur-Adminrechte ändern",
            MAKE_UNMAKE_ADMIN_TEXT: "Agentur-Adminrechte von {{user}} ändern. {{user}} kann nur in einer Agentur Admin sein.",
            UNMAKE_USER_ADMIN_TEXT: "Möchten Sie {{user}} die Agentur-Adminrechte entziehen? {{user}} kann dann keine Expedient_innen mehr zur Agentur hinzufügen oder entfernen, die Agentur nicht mehr löschen und das Agenturlogo nicht mehr bearbeiten.",
            MAKE_USER_ADMIN_TEXT: "Möchten Sie {{user}} zum Agenturadmin machen? {{user}} kann dann Expedient_innen zur Agentur hinzufügen, die Agentur löschen und das Agenturlogo bearbeiten.",
            CHANGE_USERS_AGENCY_TITLE: "Ordnen Sie {{name}} einer anderen Agentur zu",
            CHANGE_USERS_AGENCY_TEXT: "Aktuell ist {{name}} in {{oldAgency}}. Möchten Sie die Agenturzugehörigkeit von {{name}} ändern?",
            CHANGE_USERS_AGENCY_ADMIN_TEXT: "{{name}} wird seine Adminrechte in der neuen Agentur verlieren. Sie können diese aber einfach erneut zuweisen.",
        },
        CUSTOMER: {
            EDIT_CUSTOMER_TITLE: "Kund_in bearbeiten",
            CREATE_CUSTOMER_TITLE: "Kund_in anlegen",
            EDIT_CUSTOMER_TEXT: "Wenn Sie hier eine_n vorhanden Kundin_n bearbeiten, wird ein_e neue Kund_in angelegt, statt die Daten in der_die aktuelle Kund_in zu aktualisieren."
        }
    },
    ACTIVITIES: {
        CAR_BUS: {
            TITLE: "Auto/Bus",
            BUS: "Bus",
            CAR: "Auto",
            DEFAULT: {
                DIESEL: "Diesel",
                PETROL: "Benzin",
                ELECTRIC: "Elektrisch",
                UNKNOWN: "Unbekannt",
                DEFAULT: "Default"
            },
            FUEL_TYPE: {
                DIESEL: "Diesel",
                PETROL: "Benzin",
                ELECTRIC: "Elektrisch",
                UNKNOWN: "Unbekannt",
                DEFAULT: "Default"
            },
            NO_CITY: "Keine Stadt",
            NO_STREET: "Keine Straße",
            NO_ADDRESS: "Keine Adresse",
            CAR_CATEGORIES: {
                SMALL_CAR: "Kleinwagen",
                MIDDLE_CLASS: "Mittelklassewagen",
                UPPER_CLASS: "Oberklasse/Limousine",
                SUV_JEEP: "SUV/Jeep",
                MINIBUS_CAR: "Minibus",
                MIDIBUS_CAR: "Midibus"
            },
            BUS_CATEGORIES: {
                MINIBUS: "Minibus",
                MIDIBUS: "Midibus",
                CITY_BUS: "Stadtbus",
                REGIONAL_BUS: "Regionalbus",
                LONG_DISTANCE_COACH: "Reisebus",
                LUXURY_COACH: "Luxusbus"
            }
        },
        FLIGHT: {
            TITLE: "Flug",
            FLIGHT_SINGULAR: "Flug",
            FLIGHT_PLURAL: "Flüge",
            NAME: 'Flug',
            ONEWAY_SINGULAR: 'Hinflug',
            RETURN_FLIGHT_SINGULAR: 'Rückflug',
            ONEWAY_ONLY_SINGULAR: 'Nur Hinflug',
            ONEWAY_PLURAL: 'Hinflüge',
            ONEWAY_ONLY_PLURAL: 'Hinflüge',
            ROUNDTRIP_SINGULAR: 'Hin- und Rückflug',
            ROUNDTRIP_ONLY_SINGULAR: 'Hin- und Rückflug',
            ROUNDTRIP_PLURAL: 'Hin- und Rückflüge',
            ROUNDTRIP_ONLY_PLURAL: 'Hin- und Rückflüge',
            OFFSET_ENTIRE_AIRCRAFT: 'Gesamtes Flugzeug kompensieren',
            FLIGHT_TYPE: 'Flugart',
            FLIGHT_TYPE_CHARTER: 'Charter',
            FLIGHT_TYPE_LINE: 'Linie',
            FLIGHT_CLASS_FIRST: 'First Class',
            FLIGHT_CLASS_BUSINESS: 'Business Class',
            FLIGHT_CLASS_ECONOMY_PREMIUM: 'Premium Eco',
            FLIGHT_CLASS_ECONOMY: 'Eco',
            FLIGHT_NUMBER: "Flugnummer",
            DEPARTURE_AIRPORT: 'Startflughafen',
            VIA_AIRPORT: 'Umsteigeflughafen',
            ARRIVAL_AIRPORT: 'Zielflughafen',
            TRAVEL_CLASS: 'Serviceklasse',
            AIRCRAFT_TYPE: 'Flugzeugtyp',
            ADD_VIA_AIRPORT: 'Zwischenstopp hinzufügen',
            FLIGHT_COUNT: 'Flüge',
            PLACEHOLDER_AIRPORT: 'Stadt oder Flughafen',
            FLIGHT_DISTANCE: 'Flugdistanz',
            DEPARTURE_DATE: "Abflugdatum",
            CALCULATION_FAILED_FOR_LEGS: "Für folgende Abschnitte konnte keine Emissionsberechnung durchgeführt werden:",
            CALCULATION_SUCCESSFUL_FOR_LEGS_WITH_RETURN_FLIGHT: "Für folgende Abschnitte (Hin- und Rückflug) konnte eine Emissionsberechnung durchgeführt werden:",
            CALCULATION_SUCCESSFUL_FOR_LEGS_WITHOUT_RETURN_FLIGHT: "Für folgende Abschnitte konnte eine Emissionsberechnung durchgeführt werden:",
            CALCULATION_DONE_FOR_LEGS: "Die Emissionen betragen:",
            CHOOSE_FLIGHTS: "Bitte wählen Sie die passenden Flüge aus",
            DESCRIPTION: "Sie können eine Verbindung entweder über Abflug- und Ankunftsflughafen suchen oder aber über eine Flugnummer und Flugdatum. Nach Eingabe der Flugnummer und Flugdatum wird die Verbindung automatisch gesucht und Abflug- und Ankunftsflughafen werden ausgefüllt. Wenn keine Angaben zu Datum, Flugnummer, oder Serviceklasse vorliegen, wird der Emissionswert gemittelt aus allen Flügen auf diesem City Pair ausgewiesen.",
            AIRPORT_TRANSFER: "Flughafentransfer",
        },
        TRAIN: {
            TITLE: "Bahn"
        },
        HOTEL: {
            TITLE: "Hotel",
            DESCRIPTION: "Sollte ein Hotel nicht aufgelistet sein, reicht es Stadt, Land und Sternekategorie anzugeben, um den durchschnittlichen Klimafußabruck zu berechnen. Eine Unterscheidung zwischen Zimmerkategorien ist aufgrund mangelnder Datenverfügbarkeit zu diesem Zeitpunkt noch nicht möglich",
            HOTEL_CLASS_UNKNOWN: "Unbekannt"

        },
        HOSTEL: {
            TITLE: "Hostel"
        }
    },
    TRAVEL_OPTIONS: {
        TRANSPORT: {
            TITLE: "Reiseleistung",
        },
        ACCOMMODATION: {
            TITLE: "Unterkunft",
        },
        UNDERTAKING: {
            TITLE: "Aktivität",
        }
    },
    JOURNEY: {
        NUMBER_NIGHTS_LABEL: "Anzahl der Nächte"
    },
    ERRORS: {
        REGISTRATION_UPDATE_USER_INFO: "Registrierung konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.",
        TAC_UPDATE_USER_INFO: "Die allgemeinen Geschäftsbedingungen konnten nicht akzeptiert werden. Bitte versuchen Sie es erneut.",
        FAILED_CREATE_AGENCY_UPON_REGISTRATION: 'Agentur konnte nicht erstellt werden. Keine Sorge, Sie können eine Agentur unter dem Menüpunkt "Einstellungen" anlegen.',
        GENERAL_REFETCHING: "Da ist etwas schief gegangen. Bitte laden Sie die Seite erneut.",
        CLICK_AWAY_AUTOCOMPLETE_QUERY: "Bitte wählen Sie {{value}} aus der Liste aus.",
        GENERAL_NETWORK_ERROR_TITLE: "Allgemeiner Fehler",
        GENERAL_NETWORK_ERROR_BODY: 'Huch... leider ist ein technischer Fehler aufgetreten.',
        CALCULATION_PARTIAL_FAILURE: "Berechnung teilweise fehlgeschlagen",
        CALCULATION_COMPLETE_FAILURE: "Berechnung komplett fehlgeschlagen",
        ERROR_HINT: "Falls der Fehler bestehen bleibt, wenden Sie sich bitte an KlimaLink.",
        COMMON: {
            ACCEPT_TERMS: "Bitte akzeptieren Sie die AGB.",
            BASE_MIN_MAX_VALUE_EXCEEDED_MESSAGE: "Bitte geben Sie {{words}} ein die größer oder gleich {{min}} und kleiner gleich {{max}} ist.",
            MIN_MAX_PEOPLE_EXCEEDED: 'eine Anzahl von Personen',
            MIN_MAX_DAYS_EXCEEDED: 'eine Anzahl von Tagen',
            MIN_MAX_TOTAL_PASSENGER_COUNT_EXCEEDED: 'eine Gesamtanzahl der Passagiere des Busses',
            NAME: "Bitte geben Sie einen Namen ein,",
            STREET: "Bitte geben Sie ein Straße an.",
            HOUSE_NUMBER: "Bitte geben Sie eine Hausnummer an.",
            ZIP_CODE: "Bitte geben Sie eine Postleitzahl an.",
            CITY: "Bitte geben Sie eine Stadt an.",
            COUNTRY_CODE: "Bitte geben Sie einen Ländercode an.",
            COUNTRY: "Bitte geben Sie ein Land an.",
            TELEPHONE_NUMBER_WITH_AREA_CODE: "Bitte geben Sie eine Telefonnummer an.",
            EMAIL: "Bitte geben Sie eine gültige E-Mailadresse an.",
            ADDITIONAL_ADDRESS_INFORMATION: "Wenn Sie zusätzliche Adressinformationen angeben, müssen diese mindestens zwei Zeichen lang sein.",
            DESCRIPTION: "Bitte geben Sie eine gültige Beschreibung ein.",
            GENERAL: "Etwas ist schief gegangen. Bitte versuchen Sie es erneut."
        },
        SETTINGS: {
            AGENCY_USER: "Bitte wählen Sie eine Agentur für den_die Expedient_in aus.",
            FIRST_CONTACT_PERSON_FIRST_NAME: "Bitte geben Sie den Vornamen der ersten Kontaktperson an.",
            FIRST_CONTACT_PERSON_LAST_NAME: "Bitte geben Sie den Nachnamen der ersten Kontaktperson an.",
            LOADING_AGENCY_LOGO: "Agenturlogo konnte nicht geladen werden.",
        },
        FLIGHT: {
            FLIGHT_NUMBER_INVALID: "Die Flugnummer die Sie eingegeben haben ist ungültig. Flugnummern bestehen aus 1 Buchstaben und 1-4 Zahlen.",
            MIN_MAX_PASSENGERS_EXCEEDED: 'eine Anzahl an Passagieren',
            SELECT_AIRPORT_FROM_LIST: 'Bitte Flughafen angeben. Hierzu müssen Sie einen Flughafen aus der sich öffnenden Liste auswählen. Sie können nicht den Flughafen komplett selber auschreiben.',
            SELECT_AIRLINE_FROM_LIST: 'Bitte Airline angeben. Hierzu müssen Sie eine Airline aus der sich öffnenden Liste auswählen. Sie können nicht die Airline komplett selber auschreiben.',
        },
        HOTEL: {
            GIATA_ID: "Bitte geben Sie eine GIATA-ID ein.",
            MIN_MAX_ROOMS_EXCEEDED: 'eine Anzahl von Zimmern',
            MIN_MAX_NIGHTS_EXCEEDED: 'eine Anzahl von Nächten',
        },
        CAR_BUS: {
            MIN_MAX_DISTANCE_EXCEEDED: 'eine Distanz in km',
            MIN_MAX_FUEL_CONSUMPTION_EXCEEDED: "einen Treibstoffverbrauch in Liter",
            MIN_MAX_DAYS_EXCEEDED: 'eine Anzahl an Tagen',
            VEHICLE_TYPE: "Bitte wählen Sie einen Fahrzeugtyp aus",
            BUS_CATEGORY: "Bitte wählen Sie ein Buskategorie aus.",
            NOT_DISTANCE_FROM_ROUTE: "Distanz konnte nicht von der Route berechnet werden. Sie können die Distanz manuell eingeben.",
            INVALID_ACRISS_CODE: "Ungültiger Acriss-Code",
        },
        BACKEND_ERROR_CODES: {
            // Role Management
            CODE_501: "Benutzer_in ist kein Administrator.",
            CODE_504: "Maximale Anzahl von Unternehmen überschritten.",
            CODE_506: "Benutzer_in ist bereits Mitglied der TravelDatabase.",
            CODE_508: "Agentur mit demselben Namen existiert bereits.",
            CODE_509: "Eine Firma mit demselben Namen existiert bereits.",
            CODE_514: 'Expedient_in konnte nicht zur Agentur hinzugefügt werden. Bitte wenden Sie sich an den KlimaLink Support.',
            CODE_518: 'Expedient_in wurde deaktiviert. Bitte wenden Sie sich an den KlimaLink Support.',

            // Flight
            CODE_601: "Flughafen \"{{airport}}\" nicht gefunden.",
            CODE_602: "Airline \"{{airline}}\" nicht gefunden.",
            CODE_603: "Flugzeug \"{{aircraftType}}\" nicht gefunden.",
            CODE_604: "Keine Flüge für City-Pair {{airports}} gefunden.",
            CODE_605: "Flugnummer und Flugdatum nicht angegeben.",
            CODE_606: "Flugnummer nicht angegeben.",
            CODE_607: "Flugdatum nicht angegeben.",
            CODE_608: "Flugdatum \"{{flightDate}}\" konnte nicht geparst werden.",
            CODE_609: "Flugnummer \"{{flightNumber}}\" konnte nicht geparst werden.",
            CODE_610: "Der Flug ist ein Codesharing-Flug, der von einer anderen Airline durchgeführt wird. Bitte mit der Flugnummer der durchführenden Airline suchen.",
            CODE_611: "Keine Flüge für Flugnummer \"{{flightNumber}}\" und Flugdatum \"{{flightDate}}\" gefunden.",
            CODE_612: "Für den Flug \"{{flightNumber}}\" wurden mehrere City-Pairs gefunden. Bitte das gewünschte CityPair zusätzlich spezifizieren.",
            CODE_613: "Für den Flug \"{{flightNumber}}\" am \"{{flightDate}}\" wurden mehrere City-Pairs gefunden. Bitte das gewünsche CityPair zusätzlich spezifizieren.",
            CODE_614: "Für den Flug \"{{airports}},\" Airline \"{{airline}}\" und Flugzeugtyp {{aircraftType}} konten keine Flüge gefunden werden.",
            CODE_615: "Für den Flug \"{{airports}}\" und Airline \"{{airline}}\" konten keine Flüge gefunden werden.",
            CODE_616: "Für den Flug \"{{airports}}\" und Flugzeugtyp \"{{aircraftType}}\" konnten keine Flüge gefunden werden.",
            CODE_617: "Während der Emissionsberechnung ist ein Fehler aufgetreten.",
            CODE_618: "Für die Anfrage konnten keine Flüge gefunden werden.",
            CODE_619: "Der Index {{index}} kommt bei mehr als einer Activity vor.",
            CODE_620: "Fluganzahl ist 0 oder negativ.",
            CODE_621: "Passagierzahl ist 0 oder negativ.",
            CODE_622: "Die Flugnummer und das Flugdatum müssen zusammen (oder gar nicht) angegeben werden.",
            CODE_623: "Abflug und Ankunft müssen zusammen (oder gar nicht) angegeben werden.",
            CODE_624: "Es müssen entweder Flugnummer und -datum oder Abflug- und Ankunftsort angegeben werden.",
            CODE_625: "Der Abflugs- und Ankunftsflughafen sind identisch: {{departure}}, {{arrival}}.",
            CODE_627: "Pflichtparameter fehlt.",
            CODE_628: "Flüge mit Flugnummer und Flugdatum nicht gefunden.",

            // Car - Bus
            CODE_751: 'Der Kraftstoffverbrauch muss eine gültige, positive Zahl sein.',
            CODE_752: 'Die Entfernung muss eine gültige, positive Zahl sein.',
            CODE_753: 'Die Anzahl der Passagiere muss eine gültige, positive Ganzzahl sein.',
            CODE_754: 'Einer oder mehrere Wegpunkte sind ungültig.',
            CODE_755: 'Die Nutzungstage müssen eine gültige, positive Ganzzahl sein.',
            CODE_757: 'Die Buskategorie muss angegeben werden, um den Kraftstoffverbrauch pro km zu schätzen, wenn der Fahrzeugtyp ein Bus ist und der gesamte Kraftstoffverbrauch nicht angegeben wird.',
            CODE_758: 'Entweder der Acriss-Code oder die Fahrzeugkategorie muss angegeben werden, um den Kraftstoffverbrauch pro km zu schätzen, wenn der Fahrzeugtyp ein Auto ist und der gesamte Kraftstoffverbrauch nicht angegeben wird.',
            CODE_759: 'Die Nutzungstage müssen null sein, wenn der Fahrzeugtyp ein Bus ist.',
            CODE_760: 'Erster Buchstabe des Acriss-Codes falsch',
            CODE_761: 'Letzter Buchstabe des Acriss-Codes falsch',
            CODE_762: 'Erster Buchstabe des Acriss-Codes und Fahrzeugkategorie falsch',
            CODE_763: 'Letzter Buchstabe des Acriss-Codes und Fahrzeugkategorie falsch',

            // Hotel
            CODE_701: "Die Anzahl der Zimmer muss eine gültige, positive Ganzzahl sein.",
            CODE_702: "Die Anzahl der Übernachtungen muss eine gültige, positive Ganzzahl sein.",
            CODE_703: "Das Land muss ein gültiger ISO3166 Alpha3-Ländercode sein.",
            CODE_704: "Die Anzahl der Personen muss eine gültige, positive Ganzzahl sein.",
            CODE_705: "Hotels konnten nicht mit Namen, Stadt und Land gefunden werden.",

            // Request
            CODE_802: "Raten Limitierung überschritten",
            CODE_817: "Während der Emissionsberechnung ist ein Fehler aufgetreten.",
            CODE_830: "Index muss eine gültige, positive ganze Zahl sein. (angegben: {{index}}.",

            // Fusion Auth
            CODE_906: "Ihr Konto wurde deaktiviert. Bitte wenden Sie sich an Ihren Administrator, wenn dies nicht beabsichtigt war.",
            CODE_907: 'Firma nicht gefunden',
            CODE_910: 'Konnte keine E-Mail senden',
            CODE_912: 'Firmenadministrator hat Geschäftsbedingungen nicht akzeptiert',
            CODE_917: 'Expedient_in wurde deaktiviert. Bitte wenden Sie sich an den KlimaLink Support.',
        },
    },
    PDF: {
        TRAVEL_COMPONENTS: {
            PDF_TITLE: "Emissionen der Reisebausteine",
            PDF_SUBJECT: "Emissionen der Reisebausteine",
            CO2_EMISSIONS_TOTAL_FAILURE: "Keine CO2 Berechnung möglich",
            CO2_EMISSIONS_PARTIAL_FAILURE: "Für nicht alle Abschnitte konnte CO2 berechnet werden",
            FOOTER: {
                REDUCE_EMISSIONS: "Möchten Sie Ihren Klimafußabdruck verringern? Ihr Reisebüro gibt Ihnen gerne Tipps, wie Sie klimabewusster Reisen können.",
                DISCLAIMER: "Diese Daten sind ohne Gewähr und wurden ermittelt von: KlimaLink e.V.",
            }
        },
        JOURNEY: {
            PDF_TITLE: 'Ihre Reise und Emissionen',
            PDF_SUBJECT: "Ihre Reise und Emissionen",
        }
    }
}

export default german